import { react, useContext } from "react";
import * as CXT from "../../context/globalContext";

import * as S from "./styles";

export default function Button({
  children = "Button Name",
  disabled = false,
  button,
  buttonTheme = "active",
  ...rest
}) {
  const globalContext = useContext(CXT.Context);
  return (
    <S.Wrapper
      button={button}
      buttonTheme={globalContext.isLoading ? "goback" : buttonTheme}
      disabled={globalContext.isLoading || disabled}
      {...rest}
    >
      {globalContext.isLoading && buttonTheme === "active"
        ? "Carregando..."
        : !!children && children}
    </S.Wrapper>
  );
}
